export const DRAFTJS_V0 = 'draftjs-v0';
//# sourceMappingURL=draftJs.js.map